export default __webpack_public_path__ + "static/default-1_500x500-23ea686329d27c109d299c5c22179685.png";